import { NavItem } from "reactstrap";
import { Badges } from "../../../../AbstractElements";
import { Href } from "../../../../Constants/Constants";
import { TaskData } from "../../../../Data/Applications/Task/Task";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setActiveTab } from "../../../../ReduxToolkit/Reducers/TaskSlice";
import { NavClassType } from "../../../../Types/TaskType";
import { Fragment } from "react/jsx-runtime";
import { Link } from "react-router-dom";

const TaskViewData: React.FC<NavClassType> = ({ activeToggle }) => {
  const { activeTab, myTask } = useAppSelector((state) => state.task);
  const dispatch = useAppDispatch();
  const tabHandler = (tab: string) => {
    dispatch(setActiveTab(tab));
    activeToggle(tab);
  };

  return (
    <Fragment>
      {TaskData.map((item) => (
        <NavItem key={item.id}>
          <Link to={Href} className={activeTab === item.activeTab ? "active" : ""} onClick={() => tabHandler(item.activeTab)}>
            <span className="title">{item.title}</span>
            {item.badge && (
              <Badges pill color={item.color} className="text-white task-badge">
                {myTask.length}
              </Badges>
            )}
          </Link>
        </NavItem>
      ))}
    </Fragment>
  );
};
export default TaskViewData;
